import { theme } from '@smallstep/step-ui';
export default theme;
